export const unbounceSetup = () => {
  const unbounceScriptTag = document.createElement("script");
  unbounceScriptTag.type = "text/javascript";
  unbounceScriptTag.charset = "utf-8";
  unbounceScriptTag.src =
    "https://7d8aa41421c04230a0fdaa63d8bbba9a.js.ubembed.com";
  unbounceScriptTag.defer = true;
  if (document.head.appendChild) {
    document.head.appendChild(unbounceScriptTag);
  } else {
    document.head.append(unbounceScriptTag);
  }
};
